module.exports = __webpack_public_path__ + "img/scene-data.a4b96715.jpg";